import axios from 'axios'
import moment from 'moment'
import AscentiaService from './ascentiaService'

const values = {
  fullFlightData: null,
  flightData: null,
  parameterData: null,
}

const getters = {
  fullFlightData(flightOpts) {
    const flightPhaseUrl =
      flightOpts.flightPhase === 0
        ? ''
        : `&flightMode=${flightOpts.flightPhase}`

    let url =
      `/FullFlight/Flights/Airline/${flightOpts.airline}/TailNumber/` +
      `${flightOpts.aircraft}/Parameter/${flightOpts.parameter}?numFlights=${flightOpts.flightNum}${flightPhaseUrl}`

    if (flightOpts.deptDate?.dates?.startDate) {
      url +=
        '&end=' + moment(flightOpts.deptDate.dates.startDate).format('YYYYMMDD')
    }
    return axios.get(url)
  },
  flightData(flightOpts) {
    let url =
      `/FullFlight/Flights/Airline/${flightOpts.airline}/TailNumber/` +
      `${flightOpts.tail}?sort_by=RecordStartDate.desc&numFlights=${flightOpts.numFlights}`

    if (flightOpts.deptDate) {
      url += '&end=' + moment(flightOpts.deptDate).format('YYYYMMDD')
    }

    return axios.get(url)
  },
  parameterData(flightParamOpts) {
    const url =
      '/FullFlight/Flights/Airline/:airline/TailNumber/:tailNumber/FlightId/:flightId/Parameter/:paramId'
        .replace(':airline', flightParamOpts.operator)
        .replace(':tailNumber', flightParamOpts.tailNum)
        .replace(':flightId', flightParamOpts.flightId)
        .replace(':paramId', flightParamOpts.parameter)

    return axios.get(url)
  },
}

export default class FullFlightService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
